(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    if (window.slyCartDrawerRemoveAtZeroInitialized) return;

    window.slyCartDrawerRemoveAtZeroInitialized = true;

    const parseQuantity = (value, fallback = 0) => {
      const quantity = Number.parseInt(value, 10);

      return Number.isNaN(quantity) ? fallback : quantity;
    };

    const initCartDrawerCarousels = (root = document) => {
      const init = () => {
        root.querySelectorAll?.('sht-carousel').forEach((carousel) => {
          requestAnimationFrame(() => carousel.init?.());
        });
      };

      if (window.customElements?.get('sht-carousel')) {
        init();
      } else {
        window.customElements?.whenDefined('sht-carousel').then(init);
      }
    };

    const cartDrawerHasItems = (drawer) => {
      if (!drawer) return false;

      const count = parseQuantity(
        drawer.querySelector('.js-cart-drawer-count')?.textContent ||
          drawer.querySelector('.js-cart-drawer-count-number')?.textContent,
        0
      );

      return count > 0 || Boolean(drawer.querySelector('.js-cart-drawer-item'));
    };

    const restoreCartDrawerUpsell = () => {
      const template = document.getElementById('CartDrawerUpsellTemplate');
      const drawer = document.getElementById('cartDrawer');
      const footerContent = drawer?.querySelector('.js-cart-drawer-footer .cart-amount');

      if (!template || !drawer || !footerContent || !cartDrawerHasItems(drawer)) return;

      let upsell = footerContent.querySelector('.cart-drawer__upsell');

      if (!upsell) {
        upsell = template.content.firstElementChild?.cloneNode(true);

        if (!upsell) return;

        const anchor = footerContent.querySelector('.cart__discount') || footerContent.querySelector('.cart__checkout');
        anchor ? anchor.before(upsell) : footerContent.prepend(upsell);
      }

      initCartDrawerCarousels(upsell);
    };

    const scheduleCartDrawerUpsellRestore = () => {
      requestAnimationFrame(restoreCartDrawerUpsell);
      window.setTimeout(restoreCartDrawerUpsell, 100);
      window.setTimeout(restoreCartDrawerUpsell, 500);
    };

    const watchCartDrawerRefreshes = () => {
      const drawer = document.getElementById('cartDrawer');

      if (!drawer || !window.MutationObserver) return;

      new MutationObserver(scheduleCartDrawerUpsellRestore).observe(drawer, {
        childList: true,
        subtree: true,
      });
    };

    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.js-cart-drawer-quantity-btn-minus');

        if (!button) return;

        const quantityControl = button.closest('sht-cart-drwr-qty-inp');
        const input = quantityControl?.querySelector('.js-cart-drawer-quantity-input');

        if (!input) return;

        const currentQuantity = parseQuantity(input.value);
        const minimumQuantity = parseQuantity(input.min, 1);

        if (currentQuantity > minimumQuantity) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        input.value = 0;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        quantityControl.renderCartNumbers?.();
        quantityControl.handleQuickOrderListForm?.();
      },
      true
    );

    scheduleCartDrawerUpsellRestore();
    watchCartDrawerRefreshes();
  })();

  } catch(e) { console.error(e); }
})();
})();
